import React, { FC } from "react";
import { SpeciesEnum } from "../../../../__generated__/globalTypes";
import { useWebTranslation } from "translations";
import { Container } from "ui-kit/Layout";
import { FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import Switch from "ui-kit/Switch/Switch";

type ChooseBreedersAddOnProps = {
  breedersAddOn: boolean;
  onChangeBreedersAddOn: (breedersAddOn: boolean) => void;
  species: SpeciesEnum;
};

const ChooseBreedersAddOn: FC<ChooseBreedersAddOnProps> = ({
  breedersAddOn,
  onChangeBreedersAddOn,
  species,
}) => {
  const { t } = useWebTranslation();

  return (
    <>
      <Container border>
        <div
          style={{ cursor: "pointer" }}
          data-test-id={"breeders-insurance-toggle"}
          onClick={() => {
            onChangeBreedersAddOn(!breedersAddOn);
          }}
        >
          <FlexRow justifyContent="space-between">
            <div>
              <Typography variant="h4" color="grey500">
                {t("choose_breeders_add_on.option_title")}
              </Typography>
              <Gutter size={0.5} />
              <Typography variant="body3">
                {t(
                  species === SpeciesEnum.cat
                    ? "choose_breeders_add_on.option_description_cat"
                    : "choose_breeders_add_on.option_description_dog"
                )}
              </Typography>
            </div>
            <Switch active={breedersAddOn} activeColor="blue300" />
          </FlexRow>
          <Gutter size={1} />
          <Typography color="grey500">
            {t(
              species === SpeciesEnum.cat
                ? "choose_breeders_add_on.short_description_cat"
                : "choose_breeders_add_on.short_description_dog"
            )}
          </Typography>
        </div>

        {breedersAddOn && (
          <>
            <Gutter size={1} />
            <Typography variant="body3" color="grey500">
              {species === SpeciesEnum.cat
                ? t("choose_breeders_add_on.description_cat")
                : t("choose_breeders_add_on.description_dog")}
            </Typography>
          </>
        )}
      </Container>
    </>
  );
};

export default ChooseBreedersAddOn;
